import { useTranslations } from '@/i18n/context';

export function Hero() {
  const t = useTranslations('hero');
  const stats = [
    { k: t('stats.familiesK'), v: t('stats.families') },
    { k: t('stats.ratingK'), v: t('stats.rating') },
    { k: t('stats.sizesK'), v: t('stats.sizes') },
    { k: t('stats.weightK'), v: t('stats.weight') },
  ];

  return (
    <section
      id="top"
      className="relative min-h-[100svh] w-full overflow-hidden bg-[color:var(--mp-ink)] text-[color:var(--mp-cream)]"
    >
      <img
        src="https://img.alicdn.com/imgextra/i4/2216742298660/O1CN01u65JHK2DqL5NJGEPt_!!2216742298660.png"
        alt="Moepie 品牌主视觉 - 雨后小巷遛狗"
        className="absolute inset-0 h-full w-full object-cover opacity-80"
      />
      <div className="mp-noise" />
      <div className="absolute inset-0 bg-gradient-to-b from-[color:var(--mp-ink)]/40 via-transparent to-[color:var(--mp-ink)]/80" />

      <div className="relative z-10 mx-auto flex min-h-[100svh] max-w-[1440px] flex-col justify-between px-6 pt-32 pb-14 md:px-12 md:pt-40 md:pb-20 lg:px-20">
        <div className="mp-fade-up max-w-3xl">
          <div className="mb-8 flex items-center gap-3 text-[11px] uppercase tracking-[0.35em] text-[color:var(--mp-signal)]">
            <span className="h-px w-8 bg-[color:var(--mp-signal)]/80" />
            {t('est')}
          </div>
          <h1 className="font-display text-[13vw] leading-[0.9] font-medium tracking-tight md:text-[7.5vw] lg:text-[112px]">
            {t('titleLine1')}
            <br />
            <em className="font-normal italic text-[color:var(--mp-signal)]">
              {t('titleLine2')}
            </em>
          </h1>
          <p
            className="font-serif-cn mt-8 max-w-2xl text-lg leading-[2] text-[color:var(--mp-cream)]/85 md:text-xl"
            // eslint-disable-next-line react/no-danger -- trusted translation content
            dangerouslySetInnerHTML={{ __html: t('description') }}
          />

          <div className="mt-12 flex flex-wrap items-center gap-4">
            <a
              href="#collections"
              className="group inline-flex items-center gap-3 border border-[color:var(--mp-cream)]/60 px-7 py-3.5 text-[12px] uppercase tracking-[0.24em] transition-colors hover:bg-[color:var(--mp-cream)] hover:text-[color:var(--mp-forest)]"
            >
              {t('explore')}
              <span className="transition-transform group-hover:translate-x-1">
                →
              </span>
            </a>
            <a
              href="#story"
              className="mp-underline text-[12px] uppercase tracking-[0.24em] text-[color:var(--mp-cream)]/80"
            >
              {t('about')}
            </a>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-6 border-t hairline border-[color:var(--mp-cream)]/20 pt-8 md:grid-cols-4">
          {stats.map((s) => (
            <div key={s.v}>
              <div className="font-display text-3xl md:text-4xl">{s.k}</div>
              <div className="mt-1 text-[11px] uppercase tracking-[0.2em] text-[color:var(--mp-cream)]/70">
                {s.v}
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="absolute bottom-6 right-6 z-10 hidden text-[10px] uppercase tracking-[0.3em] text-[color:var(--mp-cream)]/60 md:block">
        {t('scroll')} ↓
      </div>
    </section>
  );
}
